module.exports = __webpack_public_path__ + "b.no1.9b404f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/b.no1.jpg
// module id = OgEd
// module chunks = 0